import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_DTRF_REPORT_LIST,
    getDtrfReportListFail,
    getDtrfReportListSuccess
} from '../action/getDtrfReportListAction'

// api 
import getDtrfReportListApi from '../api/getDtrfReportListApi'

export function* getDtrfReportListSaga(action) {
    try {
        const response = yield call(() => getDtrfReportListApi(action.params))
        if (response.data.statusCode === 200) {
            yield put(getDtrfReportListSuccess(response, action))
        } else {
            yield put(getDtrfReportListFail(response, action))
        }
    }
    catch (e) {
        yield put(getDtrfReportListFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_DTRF_REPORT_LIST, getDtrfReportListSaga)
}